import type { BaseQueryFn } from '@reduxjs/toolkit/query';
import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosInstance } from './_axios-instance';
import { AxiosError, AxiosRequestConfig } from 'axios';

const axiosBaseQuery =
  (): BaseQueryFn<
    {
      url: string;
      method: AxiosRequestConfig['method'];
      data?: AxiosRequestConfig['data'];
      params?: AxiosRequestConfig['params'];
      headers?: AxiosRequestConfig['headers'];
      withCredentials?: AxiosRequestConfig['withCredentials'];
    },
    unknown,
    unknown
  > =>
  async ({ url, method, data, params, headers, withCredentials }) => {
    try {
      const result = await axiosInstance({
        url,
        method,
        data,
        params,
        headers,
        withCredentials
      });
      return { data: result.data };
    } catch (axiosError) {
      const err = axiosError as AxiosError;
      return {
        error: {
          status: err.response?.status,
          data: err.response?.data || err.message
        }
      };
    }
  };

export const api = createApi({
  reducerPath: 'api',
  baseQuery: axiosBaseQuery(),
  tagTypes: [
    'Account',
    'CarePlan',
    'ContentLibraryCategory',
    'ContentLibraryTag',
    'ContentLibraryResource',
    'Coupon',
    'Invoice',
    'Medication',
    'Order',
    'OrderNote',
    'Patient',
    'PaymentMethod',
    'Prescription',
    'Product',
    'ShippingMethod',
    'Subscription',
    'Terminal',
    'User'
  ],
  endpoints: () => ({})
});
export { axiosInstance } from './_axios-instance';
